const en = {
  'home': 'Home',
  'about': 'About',
  'product': 'Products',
  'use': 'User Guide',
  'news': 'News',
  'contact': 'Contact',

  //首页
  'index1':'Read More',
  'index2':'Why Choose Us',
  'index3':'Your location',

  //关于我们
  'about1':'Company Profile',
  'about2':'Our Advantages',
  'about3':'Enterprise Honor',
  'about4':'Workshop display',
  'about5':'Our',
  'about6':'Advantage',

  //产品
  'product1':'Product Details',
  'product2':'Popular Products',

  //新闻
  'news1':'View details',
  'news2':'Information Details',
  'news3':'Previous',
  'news4':'Next',
  'news5':'Source',
  'news6':'Publication Date',

  //联系
  'con1':'Your name',
  'con2':'Your phone',
  'con3':'Your email',
  'con4':'Your address',
  'con5':'Message',
  'con6':'Submit',
  'con7':'Contact Address',
  'con8':'Dedicated Phone',
  'con9':'Business Email',
  'con10':'Online Message',


  //侧边
  'aside1':'Phone',
  'aside2':'Email',
  'aside3':'Wechat',
  'aside4':'Engage in direct dialogue with our customer service via WeChat',
  'aside5':'Scan the QR code to contact us',

   //底部
  'foot1':'Official Account',
  'foot2':'Technical Support',
  'foot3':'Chaoyiping Technology Co., Ltd',
  'foot4':'Kehui Rongsheng',






}
export default en;
